import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggleable']

  connect() {
    this.toggleClass = this.data.get('class') || 'hidden'
    // Store timeout IDs to clear them if toggled again
    this.timeouts = new Map()
  }

  toggle(event) {
    event.preventDefault()

    this.toggleableTargets.forEach((target, index) => {
      // Clear any pending timeout for this target
      if (this.timeouts.has(index)) {
        clearTimeout(this.timeouts.get(index))
        this.timeouts.delete(index)
      }

      const isHidden = target.classList.contains(this.toggleClass)
      
      if (isHidden) {
        // Show: Remove hidden first, then transition to visible
        target.classList.remove(this.toggleClass)
        // Use requestAnimationFrame to ensure the DOM update is processed
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            target.classList.remove('opacity-0')
            target.classList.add('opacity-100')
          })
        })
      } else {
        // Hide: Transition to opacity-0 first, then add hidden
        target.classList.remove('opacity-100')
        target.classList.add('opacity-0')
        // Wait for transition to complete (200ms matches duration-200)
        const timeoutId = setTimeout(() => {
          if (target.classList.contains('opacity-0')) {
            target.classList.add(this.toggleClass)
          }
          this.timeouts.delete(index)
        }, 200)
        this.timeouts.set(index, timeoutId)
      }
    })
  }
}
